import * as React from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import { useColorMode } from "./ColorMode";
import { cn } from "./lib/utils";

export const ColorModeSwitcher: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const next = colorMode === "dark" ? "light" : "dark";
  const Icon = colorMode === "dark" ? FaSun : FaMoon;
  return (
    <button
      type="button"
      onClick={toggleColorMode}
      aria-label={`Switch to ${next} mode`}
      className={cn(
        "inline-flex h-10 w-10 items-center justify-center rounded-control text-ink-muted hover:bg-surface",
        className,
      )}
    >
      <Icon />
    </button>
  );
};
